/**
 * Project Service
 * Handles the persistence and management of student projects
 */

const ProjectService = {
    /**
     * Get all projects from storage
     */
    getAllProjects() {
        return DataManager.getAll(DataManager.KEYS.PROJECTS) || [];
    },

    /**
     * Get reusable projects with a submitted request for this creator or participant.
     * The server checks the whole team without exposing their private requests.
     * @param {string} studentId - The student UUID
     * @param {string} username - The student username (used for createdBy)
     */
    getProjectsForStudent(studentId, username) {
        const all = this.getAllProjects();
        return all.filter(p => {
            const isCreator = p.createdBy && username && p.createdBy.toString().toLowerCase() === username.toString().toLowerCase();
            const isParticipant = p.participants && studentId && p.participants.includes(studentId);
            return p.hasSubmittedRequest === true && (isCreator || isParticipant);
        });
    },

    /**
     * Get project by ID
     */
    getProjectById(id) {
        return this.getAllProjects().find(p => p.id === id);
    },

    async updateParticipants(project, participants) {
        const result = await WarehouseAPI.command('projects/' + encodeURIComponent(project.id) + '/participants', 'PUT',
            {participants, expectedParticipants: project.participants}, r => WarehouseAPI.cache('projects', [r.project]));
        return result?.project || null;
    },

    /**
     * Create a new project
     * @param {Object} data - Project data { name, studentId, participants, dates }
     */
    async createProject(input) {
        const data={name:input.name,participants:input.participants || [],dates:input.dates};
        const result=await WarehouseAPI.command('projects','POST',{...data,id:WarehouseAPI.draftId('project',data)},r=>WarehouseAPI.cache('projects',[r.project]));
        return result?.project || null;
    }
};
window.ProjectService=ProjectService;
